import {Box, Typography} from '@customink/pigment-react';
import {useMobileBreakpoint} from '@customink/pigment-react/lib/utils/useBreakpoint';
import React from 'react';
import calculateUnbundledPrice from '../../utils/calculateUnbundledPrice';

const UnbundledPrice = ({
  allInclusivePriceFor25,
  currentSelectedColor,
  decorationMethod,
  unbundledPriceQty
}) => {
  const isMobile = useMobileBreakpoint();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: isMobile ? '1rem' : '1.5rem'
      }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.25rem'
        }}>
        <Typography
          xs={{
            fontSize: '1rem',
            fontWeight: 500
          }}>
          From{' '}
          <Typography fontWeight={700}>
            {calculateUnbundledPrice(
              allInclusivePriceFor25,
              decorationMethod
            )?.toLocaleString('en-US', {
              currency: 'USD',
              style: 'currency'
            })}{' '}
            ea.
          </Typography>{' '}
          for {unbundledPriceQty} items
        </Typography>
        <Typography
          sx={{
            fontSize: '0.812rem',
            fontWeight: 500
          }}>
          Before customization |{' '}
          {currentSelectedColor.minQty === 1
            ? 'No Minimum'
            : `Minimum ${currentSelectedColor.minQty}`}
        </Typography>
      </Box>
      <Typography
        sx={{
          color: 'rgba(0, 0, 0, 0.57)',
          fontSize: '0.812rem',
          fontWeight: 500
        }}>
        Add your design to get your final price
      </Typography>
    </Box>
  );
};

export default UnbundledPrice;
